// extracted by css-extract-rspack-plugin
export default {"modalImage":"src-app-pages-maintenance-break-CageReport-CageReport-module__modalImage-_Z3lKq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"modalImage\":\"src-app-pages-maintenance-break-CageReport-CageReport-module__modalImage-_Z3lKq\"}";
        // 1789362522902
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  